import { FormattedNotificationItemType, INotificationFormatter } from '@/lib/formatter/notification-formatter'
import { NotificationType } from '@/types/notification'

/**
 * PRODUCTS_PICTURE_IMPORT notification formatter
 * Extends notification with a link to the export detail page
 */
export default class ProductsPictureImportFormatter implements INotificationFormatter {
  format(notification: NotificationType): FormattedNotificationItemType {
    const id = notification.payload?.id

    const additionalParams: Array<{
      key: string
      values?: Record<string, any>
    }> = []

    if (notification.payload?.processedFiles !== undefined && notification.payload?.processedFiles !== null) {
      additionalParams.push({
        key: 'processed_files_count',
        values: { count: notification.payload.processedFiles }
      })
    }

    if (notification.payload?.successfulFiles !== undefined && notification.payload?.successfulFiles !== null) {
      additionalParams.push({
        key: 'successful_files_count',
        values: { count: notification.payload.successfulFiles }
      })
    }

    if (notification.payload?.failedFiles !== undefined && notification.payload?.failedFiles !== null) {
      additionalParams.push({
        key: 'failed_files_count',
        values: { count: notification.payload.failedFiles }
      })
    }

    if (notification.payload?.message) {
      additionalParams.push({
        key: notification.payload.message
      })
    }

    return {
      ...notification,
      additionalParams,
      link: id ? `/products/import/picture/${id}` : undefined
    }
  }
}
